import { addEvent } from "features/authentication/userSlices";
import { useDispatch, useSelector } from "react-redux";

enum EventTypes {
    PROFILE_VIEW = "Changement de profil",
    LOGIN = "Connexion",
    GENERATE_PDF = "Générer un portefeuille conseillé",
    VIDEO_VIEW = "Visionnage vidéo",
    PDF_CLICK = "Clic sur PDF"
}
export const useElkanoAnalytics = () => {
    const dispatch:Function = useDispatch();
    const user = useSelector((state:any) => state.auth.user);

    const addProfileViewEvent = async (profile: string) => {
        await addAnalyticsEvent(EventTypes.PROFILE_VIEW, profile);
    };

    const addGeneratePdfEvent = async (profile: string) => {
        await addAnalyticsEvent(EventTypes.GENERATE_PDF, profile);
    }

    const addLoginEvent = async () => {
        await addAnalyticsEvent(EventTypes.LOGIN, "N/A");
    }

    const addVideoViewEvent = async (videoTitle: string) => {
        await addAnalyticsEvent(EventTypes.VIDEO_VIEW, videoTitle);
    }

    const addPdfClickEvent = async (pdfName: string) => {
        await addAnalyticsEvent(EventTypes.PDF_CLICK, pdfName);
    }

    const addAnalyticsEvent = async (eventType: EventTypes, profile: string) => {
        if (!user) return; // Guard clause in case user is not logged in yet
        
        const event = {
            firstname: user.firstname,
            lastname: user.lastname,
            email: user.email,
            company: user.company,
            type: eventType,
            profile: profile,
            date: new Date().toISOString()
        
        }
        dispatch(addEvent(event))
    }
    return { 
        addProfileViewEvent, 
        addGeneratePdfEvent, 
        addLoginEvent, 
        addVideoViewEvent, 
        addPdfClickEvent 
    };
};
